import { inject, Injectable } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { doc, DocumentReference, getDoc } from "firebase/firestore";
import { IOrganization, UUID } from "src/app/core/interfaces";

interface IOrganizationService {
  getOrg(orgId: UUID): Promise<IOrganization>;
}

@Injectable({
  providedIn: 'root'
})
export class OrganizationService implements IOrganizationService {
  private firestore: Firestore = inject(Firestore);

  private getOrgDoc(orgId: UUID): DocumentReference<IOrganization> {
    return doc(
      this.firestore,
      `organization/${orgId}`
    ) as DocumentReference<IOrganization>;
  }

  public async getOrg(orgId: UUID): Promise<IOrganization> {
    const orgDoc = this.getOrgDoc(orgId);
    const orgSnap = await getDoc(orgDoc);

    if (!orgSnap.exists()) {
      throw new Error("Organization not found");
    }

    return orgSnap.data();
  }
}
